import { partnerService } from "@/common/api.service";
import { GET_PARTNER_LIST } from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";
const state = {
  errors: null,
  partner_list: {},
};

const getters = {
  partner_list(state) {
    return state.partner_list;
  },
};

const actions = {
  async [GET_PARTNER_LIST](context) {
    partnerService.init();
    partnerService.setHeader();
    context.commit(ISLOADING, true);
    const data = await partnerService.get("user/customer-groups");
    context.commit(ISLOADING, false);
    return data;
  },
};
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
